/*
 * It sets a fixed pixel height on an element, based on a combination the current window height and
 * a top offset (for example, the height of a banner) which is supplied by the topOffset @Input.
 *
 * The directive is based on https://dev.to/nikosanif/how-to-set-dynamic-height-at-element-with-angular-directive-5986
 */

import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { fromEvent } from "rxjs";
import { debounceTime, throttleTime } from "rxjs/operators";

@Directive({
    selector: "[appFluidHeight]",
    standalone: false
})
export class FluidHeightDirective implements AfterViewInit {
    @Input() minHeight: number;
    @Input() topOffset: number;

    private domElement: HTMLElement;

    constructor(private elementRef: ElementRef) {
        this.domElement = this.elementRef.nativeElement as HTMLElement;

        // register on window resize event
        fromEvent(window, "resize")
            .pipe(throttleTime(500), debounceTime(500))
            .subscribe(() => this.setHeight());
    }

    ngAfterViewInit() {
        this.setHeight();
    }

    private setHeight() {
        const windowHeight = window?.innerHeight;
        const offset = this.topOffset || 600;
        let height = windowHeight - offset;

        // set min height instead of the calculated
        if (this.minHeight && height < this.minHeight) {
            height = this.minHeight;
        }

        this.domElement.style.height = `${height}px`;
        this.domElement.style.overflowX = 'hidden';
        this.domElement.style.overflowY = 'auto';
    }
}
